import React from 'react';
import { PrivacyPolicyContainer } from '../PrivacyPolicy/PrivacyStyles.styles';

const Acceptance = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>Acceptance of Terms</h3>

      <p>
        By accessing or using the Yoda Safety Services website, platform, or
        services, you acknowledge that you have read, understood, and agree to
        be bound by these Terms & Conditions and any additional terms that apply
        to specific services, purchases, subscriptions, or agreements.
      </p>

      <p>
        These Terms apply to users of our website, training platform, and
        services, including individual learners, employees, company managers and
        representatives, subcontractors, and other authorized users.
      </p>

      <h4>Account Responsibility</h4>

      <p>
        Users are responsible for maintaining the confidentiality of their
        account credentials and for taking reasonable steps to prevent
        unauthorized access to their accounts. Login credentials must not be
        shared with unauthorized individuals.
      </p>

      <p>
        You are responsible for activity conducted through your account where
        that activity results from your authorized use or your failure to
        reasonably protect your account credentials. If you believe your account
        has been accessed or used without authorization, you should notify Yoda
        Safety Services promptly.
      </p>

      <h4>Company and Organization Accounts</h4>

      <p>
        Where an account is created, managed, or used on behalf of a company or
        other organization, the individual acting on behalf of that organization
        represents that they are authorized to do so.
      </p>

      <p>
        Company managers and other authorized representatives may be permitted
        to manage users, purchase and assign training, access training records
        and certificates, manage subscriptions, and access other company
        resources in accordance with the permissions available through the
        platform.
      </p>

      <p>
        Companies and organizations are responsible for ensuring that access
        granted to their managers, employees, subcontractors, and other
        authorized users is appropriate and for promptly updating or removing
        access when it is no longer required.
      </p>

      <h4>Third-Party Services</h4>

      <p>
        Certain features of our services rely on third-party providers,
        including payment processing and other technology services. Your use of
        a third-party service may also be subject to that provider&apos;s
        applicable terms and policies.
      </p>

      <p>
        Payments made through the platform are processed through Stripe or
        another authorized payment processor and are subject to the applicable
        payment processor&apos;s terms and policies.
      </p>

      <h4>Additional Agreements</h4>

      <p>
        Certain company accounts, subscriptions, custom documentation services,
        or other products and services may be subject to additional agreements,
        proposals, service terms, or requirements. Where additional terms apply,
        they form part of the agreement governing the applicable product or
        service.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default Acceptance;
